import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import ConsentGate from './ConsentGate';
import { AccountType } from '../types';

export const ComplianceWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading, updateConsent, logout } = useAuth();
  // Local flag: flips true the moment user taps Accept, forces gate to dismiss
  // immediately without waiting for Firestore write to propagate back through the listener.
  const [hasConsented, setHasConsented] = useState(false);

  if (loading) return <>{children}</>;

  // localStorage key is per-user so switching accounts works correctly
  const consentKey = user ? `homphy_consent_${user.id}` : null;
  const localConsent = consentKey ? !!localStorage.getItem(consentKey) : false;

  const needsConsent =
    !hasConsented &&
    user !== null &&
    user !== undefined &&
    user.accountType !== AccountType.ADMIN &&
    !localConsent &&
    (!user.consentFlags || !user.consentFlags.dataProcessing);

  if (needsConsent) {
    return (
      <>
        <ConsentGate
          isProvider={user.accountType === AccountType.PROVIDER}
          onAccept={async (flags) => {
            // Dismiss gate immediately — don't wait for Firestore
            setHasConsented(true);
            if (consentKey) localStorage.setItem(consentKey, '1');
            try {
              await updateConsent({
                location: flags.location ?? false,
                dataProcessing: true,
                aiRecommendations: (flags as any).ai ?? (flags as any).aiRecommendations ?? false,
                marketing: false,
              });
            } catch (e) {
              // Firestore write failed — gate already dismissed via local state + localStorage.
              // Will sync to Firestore on next successful write.
              console.warn('[ComplianceWrapper] consent write failed, saved locally:', e);
            }
          }}
        />
        {/* Safety escape: lets the user log out if they're stuck on the consent gate */}
        <button
          onClick={() => logout()}
          style={{
            position: 'fixed', bottom: 16, left: 16, zIndex: 9998,
            fontSize: '0.7rem', fontWeight: 700, color: '#94a3b8',
            background: 'transparent', border: 'none', cursor: 'pointer',
            textDecoration: 'underline', padding: '4px 8px',
          }}
        >
          Log out
        </button>
      </>
    );
  }

  return <>{children}</>;
};